<template>
    <div id="app">
        <div>
            <router-view />
        </div>
    </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
    };
  },
  created() {
    this.startUserListener()
  }
};
</script>
<style scoped>
    @import url("https://fonts.googleapis.com/css?family=Yantramanav:300,400,500");
    #app {
        font-family: 'Yantramanav', Verdana, Arial, Helvetica, sans-serif;
        overflow: hidden;
    }
</style>